// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "dialog__paper-1g9Z1";
export { _1 as "__esModule", _2 as "tablet", _3 as "dialog__paper" }
export default { "__esModule": _1, "tablet": _2, "dialog__paper": _3 }
